export const news = [
  {
    id: "1",
    title: "《公公与儿媳》全剧收官，家庭题材再掀追剧热潮",
    date: "2024-03-21",
    category: "剧集动态",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20big%20happy%20chinese%20family%20gathered%20in%20a%20bright%20new%20living%20room%20celebrating%20together%2C%20joyful%20warm%20mood%2C%20soft%20natural%20lighting%2C%20muted%20amber%20and%20red%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-01&orientation=landscape",
    summary: "收官之夜收视登顶家庭剧榜首，观众热议“最像自己家的一部剧”。",
    content: "随着第20集《团圆》的播出，《公公与儿媳》正式收官。据收视数据显示，该剧在收官之夜登上同时段家庭题材剧收视榜首，网络讨论量突破千万。不少观众在评论区留言，说剧里的饭桌、院子、拌嘴，都像极了自己的家。制片方表示，这部剧的初衷就是“拍一顿所有人都吃过的团圆饭”，如今能得到这样的反馈，主创团队倍感欣慰。",
  },
  {
    id: "2",
    title: "幕后花絮：那场“第一顿团圆饭”拍了整整一天",
    date: "2024-03-19",
    category: "幕后花絮",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20behind%20the%20scenes%20still%20of%20a%20film%20crew%20setting%20up%20a%20dining%20table%20scene%20in%20a%20traditional%20chinese%20courtyard%2C%20warm%20practical%20lighting%2C%20muted%20warm%20tones%2C%20documentary%20candid%20mood%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-02&orientation=landscape",
    summary: "导演透露，为了保证饭菜“冒着热气”，剧组反复重拍了十几遍。",
    content: "第2集里那桌丰盛的团圆饭，是全剧拍摄周期最长的一场戏。据现场工作人员回忆，为了拍出饭菜最真实的热气，道具组每拍一条就要重新做一道菜，演员们前前后后“吃”了十几顿。饰演陈老根的李国强笑称：“拍完这场戏，我是真的吃不下了。”正是这份较真，才有了剧中最有烟火气的一幕。",
  },
  {
    id: "3",
    title: "角色解析：陈老根的“固执”其实是一种深情",
    date: "2024-03-18",
    category: "角色解析",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20kindly%20elderly%20chinese%20grandfather%20sitting%20alone%20deep%20in%20thought%20in%20a%20courtyard%20at%20dusk%2C%20reflective%20mood%2C%20soft%20golden%20lighting%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-03&orientation=landscape",
    summary: "看似不近人情的公公，其实是全剧情感最饱满的角色之一。",
    content: "很多观众一开始并不喜欢陈老根，觉得他固执、嘴硬、爱摆架子。可随着剧情推进，人们慢慢发现，他的每一分固执背后，都是对家人的在乎。他不肯动那面青砖墙，是因为那里刻着老伴的影子；他嘴上嫌弃儿媳的手艺，转身却把汤喝得一滴不剩。人物越是“不好相处”，越显得他的柔软珍贵。这也是《公公与儿媳》最打动人的地方。",
  },
  {
    id: "4",
    title: "播出信息：《公公与儿媳》全集已上线，支持回看",
    date: "2024-03-18",
    category: "播出信息",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20television%20screen%20showing%20a%20family%20drama%20in%20a%20cozy%20warm%20chinese%20living%20room%2C%20soft%20evening%20lighting%2C%20muted%20warm%20tones%2C%20nostalgic%20viewing%20mood%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-04&orientation=landscape",
    summary: "全20集内容均已整理上线，本站提供分集剧情介绍与回看辅助。",
    content: "目前《公公与儿媳》全20集内容已经整理完毕。本站为方便观众回顾剧情，将每一集的剧情梗概、出场角色和看点做了系统梳理。需要说明的是，本站仅提供剧情文字介绍与剧集推荐，不提供视频播放与下载，具体播出安排请以官方平台为准。",
  },
  {
    id: "5",
    title: "观众热议：为什么大家都心疼林晓梅？",
    date: "2024-03-16",
    category: "角色解析",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20graceful%20young%20chinese%20woman%20standing%20quietly%20in%20a%20kitchen%20looking%20thoughtful%2C%20soft%20natural%20lighting%2C%20subtle%20emotion%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-05&orientation=landscape",
    summary: "独立又要强的儿媳形象，让无数有过相似经历的观众产生了共鸣。",
    content: "林晓梅这个角色之所以让人心疼，是因为她太“懂事”了。她把委屈咽下去，把活计揽过来，从不抱怨一句。可越是这样，观众越替她不值。有观众评论：“她不是没有脾气，是把脾气都留给了自己。”这种克制的表演方式，让林晓梅成了近年来家庭剧里格外真实的女性形象之一。",
  },
  {
    id: "6",
    title: "幕后花絮：老宅的取景地原来在这里",
    date: "2024-03-14",
    category: "幕后花絮",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20behind%20the%20scenes%20still%20of%20a%20traditional%20chinese%20courtyard%20house%20film%20location%20with%20a%20big%20old%20tree%20and%20grey%20brick%20walls%2C%20soft%20afternoon%20lighting%2C%20muted%20warm%20tones%2C%20documentary%20mood%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-06&orientation=landscape",
    summary: "那间承载全剧情感的老宅，是真真实实存在于一条老街上的百年院落。",
    content: "剧组透露，剧中的陈家老宅并非搭建的布景，而是一处真实保存下来的百年四合院。为了不破坏原有建筑，剧组只做了极少的修补，连院里的老槐树都是自然生长的。饰演王桂芬的王秀兰感慨：“每次走进这个院子，都有一种真回了家的感觉。”",
  },
  {
    id: "7",
    title: "剧情回顾：那些让观众泪目的名场面",
    date: "2024-03-12",
    category: "剧集动态",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20collage%20still%20of%20emotional%20family%20drama%20moments%20in%20a%20chinese%20home%2C%20tender%20moving%20mood%2C%20soft%20warm%20lighting%2C%20muted%20amber%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-07&orientation=landscape",
    summary: "从深夜长谈到生日惊喜，盘一盘全剧最催泪的几个瞬间。",
    content: "如果要选出全剧最催泪的时刻，第13集的深夜长谈一定榜上有名。父子俩坐在台阶上，一盏灯、两碗茶，把压了半辈子的话说开。还有第14集里林晓梅守在病床前的一幕，没有一句煽情的台词，却让人看得眼眶发热。好的家庭剧从不靠大吼大叫，而是靠这些安静的、真实的瞬间。",
  },
  {
    id: "8",
    title: "角色解析：陈建国才是最难的那个“夹心人”",
    date: "2024-03-10",
    category: "角色解析",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20tired%20chinese%20middle%20aged%20man%20sitting%20between%20two%20rooms%20deep%20in%20thought%2C%20weary%20but%20kind%20expression%2C%20soft%20dim%20lighting%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-08&orientation=landscape",
    summary: "一边是父亲，一边是妻子，他的成长是全剧另一条隐藏主线。",
    content: "很多人忽略了陈建国。他不是坏人，只是太想息事宁人。他夹在父亲和妻子中间，两头讨好，却两头不落好。可正是这样一个普通的男人，在剧情推进中一点点学会了倾听、学会了表态、学会了承担。他的转变，其实比任何激烈的冲突都更有力量。",
  },
  {
    id: "9",
    title: "《公公与儿媳》入选年度家庭题材剧推荐榜",
    date: "2024-03-08",
    category: "剧集动态",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20a%20family%20drama%20awards%20recommendation%20banner%20in%20warm%20red%20and%20amber%20tones%2C%20celebratory%20mood%2C%20soft%20lighting%2C%20muted%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-09&orientation=landscape",
    summary: "凭借扎实的剧本和真实的人物，该剧被评为年度最值得一看的家庭剧之一。",
    content: "在近期公布的一份年度家庭题材剧推荐榜单中，《公公与儿媳》成功入选。推荐语这样写道：“它没有狗血的桥段，也没有刻意的煽情，只是老老实实讲了一家人如何学会彼此理解。”在家庭剧普遍追求强冲突的当下，这种克制与真诚，本身就显得难能可贵。",
  },
  {
    id: "10",
    title: "幕后花絮：演员为角色学做北方菜",
    date: "2024-03-06",
    category: "幕后花絮",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20behind%20the%20scenes%20still%20of%20an%20actor%20learning%20to%20cook%20traditional%20northern%20chinese%20dishes%20in%20a%20rustic%20kitchen%2C%20focused%20warm%20mood%2C%20soft%20daylight%2C%20muted%20warm%20tones%2C%20documentary%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-10&orientation=landscape",
    summary: "为了演好厨房里的戏，几位演员开机前专门去学了地道北方菜。",
    content: "厨房是全剧出现最多的场景之一。为了让切菜、颠勺的动作看起来足够自然，几位主演在开机前跟着当地的老师傅学了近一个月。饰演王桂芬的王秀兰说：“做饭的手势骗不了人，观众一眼就能看出来真假。”这份用心，成就了剧中那些热气腾腾的日常。",
  },
  {
    id: "11",
    title: "剧情导读：想看懂这部剧，先看懂这三顿饭",
    date: "2024-03-04",
    category: "剧集动态",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20still%20of%20three%20covered%20chinese%20home%20cooked%20meals%20on%20a%20warm%20wooden%20table%2C%20cozy%20domestic%20mood%2C%20soft%20natural%20lighting%2C%20muted%20amber%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-11&orientation=landscape",
    summary: "从第一顿别扭的团圆饭，到最后一顿圆满的年夜饭，饭桌就是这部剧的隐喻。",
    content: "《公公与儿媳》其实是用三顿饭串起来的：第2集那顿尴尬的团圆饭，第18集那顿温暖的生日宴，以及第20集那顿圆满的年夜饭。从拘谨到松弛，从隔阂到团圆，饭桌上的变化，就是这一家人关系的全部注脚。想读懂这部剧，不妨先读懂这三顿饭。",
  },
  {
    id: "12",
    title: "主创专访：我们想拍的是“每个普通人的家”",
    date: "2024-03-02",
    category: "剧集动态",
    thumbnail:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20interview%20still%20of%20a%20film%20director%20sitting%20in%20a%20warm%20study%20talking%20about%20family%2C%20thoughtful%20sincere%20expression%2C%20soft%20indoor%20lighting%2C%20muted%20warm%20tones%2C%20film%20grain%2C%20harmonious%20composition&width=800&height=600&seq=news-cover-12&orientation=landscape",
    summary: "导演表示，全剧最大的追求就是真实——不美化，也不丑化任何一个家庭成员。",
    content: "在接受采访时，导演谈到了创作初衷：“我们没有把公公写成恶人，也没有把儿媳塑造成完美受害者。每个人都有自己的立场，也都有自己不对的地方，这才是真实的家庭。”正是这种不站队的克制，让《公公与儿媳》没有落入脸谱化的俗套，也让每个观众都能在剧中找到自己家的影子。",
  },
];